import api from "./index";

export interface EducationListenersListParams {
  courseId: string;
  hasProtocol?: boolean;
  testCompleted?: boolean;
  practiceCompleted?: boolean;
  createdAtMin?: Date;
  createdAtMax?: Date;
  passedAtMin?: Date;
  passedAtMax?: Date;
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: EducationListenersListParams, options?: any) => {
  return api.EducationProtocolApi.listeners(
    params.courseId,
    params.hasProtocol,
    params.testCompleted,
    params.practiceCompleted,
    params.createdAtMin,
    params.createdAtMax,
    params.passedAtMin,
    params.passedAtMax,
    params.offset,
    params.limit,
    options
  );
};
